/* iot_os_plan.icon.svg.js */

module.exports = {
    icon: `
       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="foreground-gl" d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM4.78613 18.4199L6.2207 20.0127L8.74609 17.7373L11.8672 21.4512L17.585 15.3525H14.3174V12.7217L19.2139 8.3125L17.7793 6.71973L4.78613 18.4199ZM6.14941 8.64746H9.41699L9.46484 11.6562L13.6104 7.94531L15.2285 6.5332L11.8672 2.54883L6.14941 8.64746Z" fill="#2AA6DA"/>
</svg>
    `,
};
